import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserGlobalService } from '../../../../services/user-global.service';
import { UsersService } from '../../../../services/users.service';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { NkSharedModule } from '../../../../shared/shared.module';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'app-quick-panel',
  templateUrl: './quick-panel.component.html',
  styleUrls: ['./quick-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    MomentModule,
    NkSharedModule,
    RouterModule,
    MatCardModule,
    MatIconModule,
    MatSidenavModule
  ],
 
})
export class NkQuickPanelComponent implements OnInit {
  public activityData: any;
  public user: any;
  public date: Date = new Date();
  public settings = {
    notify: true,
    cloud: false,
    retro: true
  };

  constructor(
    private readonly userGlobalService: UserGlobalService,
    private readonly usersService: UsersService
  ) {}

  ngOnInit() {
    this.user = this.userGlobalService.user;
    this.myActivity();
  }

  public myActivity() {
    this.usersService.getActivity(this.user?.id, {
      filter: {
        condition: 'AND',
        rules: [],
        valid: true
      },
      config: {
        sort: 'id',
        order: 'ASC',
        page: 1,
        limit: 50
      }
    }).subscribe((v: any) => {
      this.activityData = v.data;
    
    });
  }
}
